module.exports = __webpack_public_path__ + "static/media/Preview.47709bdc.png";